export default __webpack_public_path__ + "static/media/event.f8b32ed7.jpg";